import React from 'react';
import { SideNav } from '../../components/SideNav';
import { PageWrapper, Page, PageContent } from './PageTemplates';

const ManagerPage: React.FC = ({ children }) => (
  <PageWrapper>
    <Page>
      <SideNav userRole="Manager" />

      <PageContent>{children}</PageContent>
    </Page>
  </PageWrapper>
);

export default ManagerPage;
